module.exports = __webpack_public_path__ + "static/media/checked.a5830883.svg";